module.exports = __webpack_public_path__ + "images/uphold.6ab5898f87dce78cdae4b65ad73c6363.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/logos/uphold.png
// module id = 1020
// module chunks = 0